import { render, staticRenderFns } from "./FormExpense.vue?vue&type=template&id=1b18dcbe&scoped=true&"
import script from "./FormExpense.vue?vue&type=script&lang=js&"
export * from "./FormExpense.vue?vue&type=script&lang=js&"
import style0 from "./FormExpense.vue?vue&type=style&index=0&id=1b18dcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b18dcbe",
  null
  
)

export default component.exports